import React from 'react';
import moment from 'moment-timezone';

import Text from 'components/Text';

export type CoachingScheduleInstanceProps = {
  startDateTime: string;
  endDateTime: string;
  participantName: string;
  subjectName: string;
  isCancelled: boolean;
  studentGradeLevel?: string | null;
};

export default function CoachingScheduleInstanceDescription(props: CoachingScheduleInstanceProps) {
  const {
    startDateTime,
    endDateTime,
    participantName,
    subjectName,
    studentGradeLevel,
    isCancelled,
  } = props;
  const dateTimeString = moment(startDateTime)
    .tz(moment.tz.guess())
    .format('LT');
  const duration = moment(endDateTime).diff(startDateTime, 'minutes');
  const participantString = `with ${participantName} • ${duration} min`;
  return (
    <React.Fragment>
      <Text
        data-test="coach-schedule-instance-description-date"
        element="div"
        weight="normal"
        size="xsmall"
        color={isCancelled ? 'graphite' : 'chalkboard'}>
        {dateTimeString} {participantString}
      </Text>
      <Text
        data-test="coach-schedule-instance-student-data"
        element="div"
        weight="normal"
        size="xsmall"
        color="graphite">
        {studentGradeLevel} • {subjectName}
      </Text>
    </React.Fragment>
  );
}
